import useMountEffect from '@restart/hooks/useMountEffect';
import { RiLoopRightLine } from 'react-icons/ri';
import { useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

import actions from '@/actions';
import GyroscopeModal from '@/components/modals/calibration/Gyroscope';
import { modalManager } from '@/libs/ModalContainer';

const Panel = ({ data: [robot] }) => {
  const dispatch = useDispatch();

  useMountEffect(() => {
    modalManager.show(GyroscopeModal, { robot });
    dispatch(actions.command.resetActivePanels());
  });

  return null;
};

const Command = {};
Command.id = uuidv4();
Command.name = 'Gyroscope';
Command.displayMode = 'sidebar';
Command.singleRobotOnly = true;
Command.commanderOnly = true;
Command.Icon = RiLoopRightLine;
Command.Panel = Panel;

export default Command;
